export const Href = "#javascript";

// Login Form
export const CreateAccount = "Create Account";
export const DoNotAccount = "Don't have account?";
export const EmailAddress = "Email Address";
export const UserName = "Username";
export const ForgotPassword = "Forgot password?";
export const Password = "Password";
export const RememberPassword = "Remember password";
export const SignIn = "Sign In";
export const SignInAccount = "Sign in to account";
export const SignInWith = "Or";
export const FacebookHeading = "facebook";
export const TwitterHeading = "twitter";
export const LinkedInHeading = "LinkedIn";
export const ThemeColorMode = "Template color mode";
export const SidebarIconHeading = "Sidebar icon:";
export const LayoutTypeHeading = "Layout type:";
export const SidebarTypeHeading = "Sidebar type:";
export const UnlimitedColorHeading = "Unlimited color:";

// Header
export const SearchAnything = "Search anything...";
export const SearchHere = "Search here...";
export const Notifications = "Notifications";
export const View = "View";
export const AllNotification = "All Notification";
export const Bookmark = "Bookmark";
export const AddNewBookmark = "Add New Bookmark";
export const Cart = "Cart";
export const Total = "Total";
export const Checkout = "Checkout";
export const Messages = "Messages";
export const PreviewSettings = "Preview Settings";
export const Document = "Document";

//Registration
export const RegisterTitle = "User Register";
export const RegisterUser = "Registration";

//Thank You Register
export const ThankYouRegisterTitle = "User Register";
export const ThankYouRegisterUser = "Registration";

// Sidebar
export const Pinned = "Pinned";
export const Back = "Back";
export const BuyNow = "Buy Now";

// Page Layout
export const SampleCards = "Sample Card";
export const SamplePage = "Sample Page";

// Dashoard Layout
export const Dashboard = "Dashboard";
export const DashboardPage = "Dashboard";
export const ReferralURLHeading = "Share Your URL";
export const TotalDispatch = "Dispatch";
export const MyWallet = "Wallet";
export const totalBal = "Total Balance";
export const Project = "Team Dashboard";
export const InvestingHeading = "Coupon Code";
export const Weekly = "Weekly";
export const Monthly = "Monthly";
export const Yearly = "Yearly";
export const AllIncomeHeading = "All Income";
export const TotalInvestmentHeading = "Total Investment";
export const MonthlyOverviewHeading = "Monthly Overview";
export const Progress = "Progress";
export const TaskSummaryHeading = "Team Overview";
export const OurCrew = "Our Team";
export const TeamMembers = "Team Memebers";
export const Accept = "Accept";
export const Decline = "Decline";
export const NotificationsHeading = "Notifications";
export const TopAchivers = "Top Achievers";
export const CurrentBonanzaHeading = "Current Bonanza";
export const RewardHighlightedHeading = "Latest News";
export const DownloadAppHeading = "Bot Royalty";
export const Month = "Month";
export const Year = "Year";
export const Hours = "Hours";
export const BusinessOverviewHeading = "Team Business Overview";
export const YourName = "Your Name";

//Registration
export const EnterYourFirstName = "Enter your first-name";
export const EnterYourLastName = "Enter your last-name";
export const AgreeWith = "Agree with";
export const CreateYourAccount = "Create your account";

export const EmailsPlaceHolder = "Test@gmail.com";
export const PrivacyPolicy = "Privacy Policy";
export const SignUpWith = "Or";
export const FirstName = "First name";
export const LastName = "Last name";
export const SponsorID = "Sponsor ID";
export const SponsorName = "Sponsor Name";
export const FullName = "Full Name";
export const MobileNo = "Mobile Number";
export const Country = "Choose Country";
export const Otp = "OTP";

//My Profile

export const EditProfile = "Edit Profile";
export const profile = "Profile";
export const Address = "Address";
export const City = "Users";
export const AboutMe = "Users";
export const Company = "Users";
export const Emailaddress = "Users";
export const PostalCode = "Users";
export const UpdateProfile = "Update";
export const Username = "Users";
export const Bio = "Users";
export const MyProfile = "Users";
export const Save = "Users";
export const Website = "Users";

export const NomineeName = "Nominee Name";
export const NomineeRelation = "Nominee Relation";

export const ReactstrapTabs = "Reactstrap Tabs";
export const Tabs = "Tabs";
export const SimpleTab = "Simple tabs";
export const IconsWithTab = "Icons With tabs";
export const VerticalTab = "Vertical tabs";
export const PillsTab = "Pills tabs";
export const JustifyTab = "Justify tabs";
export const MaterialStyleLeftTab = "Material style left tabs";
export const DalbultCaslin = "Dalbult Caslin ";
export const MaterialStyleTab = "Material style tabs";
export const BorderTab = "Edit Your Profile Details ";
export const Contact = "Contact";
export const Components = "Components";
export const PageTab = "Page";
export const AboutUs = "About us";
export const Blog = "Blog";
export const UxDesigner = "UX designer";
export const IOTDeveloper = "IOT developer";
export const User = "User";
export const Review = "Review";
export const ExampleTextarea = "Example textarea";
export const Personal = "Personal Details";
export const Nominee = "Nominee Details";
export const UpdatePassword = "Password Details";
export const Settings = "Settings";
export const Inbox = "Inbox";
export const Description = "Description";

export const Title = "Title";
export const Name = "Name";
export const Gender = "Gender";
export const DOB = "Date Of Birth";
export const Fathername = "Father's Name";
export const MaritalStatus = "Marital Status";
export const EmailId = "Email Id";
export const telephone = "Alternate Number";

export const State = "State";
export const chooseCity = "Choose City";
export const choosePincode = "Choose Pincode";

export const Welcomeletter = "Welcome Letter";
export const MyIdCard = "My Id Card";

export const CryptoWallet = "Crypto Wallet";
export const BankInr = "Bank INR";
export const BankAED = "Bank AED";
export const creditcard = "Credit Card Details";
export const AccountSettings = "Settings";
export const BankSettings = "Bank Settings";

export const ActivateBot = "Activate Bot";
export const Activatetitle = "Activation";
export const BotaDetailHeading = "bot Information";

export const BonanzaPage = "Bonanza Eligible Report";

export const RewardTitle = "Reward";
export const SearchTableButton = "Search";
export const ServerSideProcessingHeading = "Reward";

export const LifeRewardTitle = "Life Time Reward";

export const UsdtTRCTitle = "Request USDT(TRC20)";
export const UsdtBEPTitle = "Request USDT(BEP20)";
export const LastTransactionHeading = "Last Transaction History";
export const FundINRTitle = "Request Fund INR";
export const DepositFundTitle = "Deposit Fund";
export const DepositHistoryTitle = "Deposit History";
export const RefferalTitle = "Referral Income Report";
export const TransectionRepoTitle = " Transection Logs";
export const TokenHistoryTitle = "Token History";
export const FXSTTokenHistory = "FXST Token History";
export const FundINRReport = "Request Fund Report";
export const Wallet_PayReport = "Wallet Transfer Report";

export const WalletTransferDeposit = "Transfer Trading Profit To Deposit";
export const WalletTransferFxstock = "Transfer to Fxstock Wallet";
export const WalletTransferFxstPay = "Transfer to Fxst Pay Wallet";
export const WalletTransfer = "Wallet Transfer";

export const P2P = "P2P Transfer";

export const P2PTransferReport = "P2P Report";

export const WithdrawTitle = "Withdraw";
export const RequestWithdraw = "Request Withdraw";

export const WithdrawHistory = "Withdraw History";

export const BotLevelIncome = "Bot Level Income";
export const ProfitSharingIncome = "Profit Sharing Income";
export const MonthlyProfitIncome = "Monthly Profit Income";
export const CashLevelIncome = "Cash Level Income";
export const RoyaltyLogIncome = "Royalty Log Income";

export const PayoutTitle = "Payout";
// Common Modal
export const ScrollingContent = "Hello";
export const ScrollingModalHeading = "Account Details";
export const SaveChanges = "Save Changes";
export const Close = "Close";

// Team OverView
export const myTeamBusiness = "Team Business";
export const TeamOverViewTitle = "Team Overview";
export const My_Direct = "My Direct";
export const Income = "My Income";
export const DownlineTitle = "Team Downline";
export const Level_Wise_Report = "Levelwise Report";
export const BusinessReport = "Business Report";
export const Tree_GenrateReport = "Generation Tree";

export const Activation = "Activation";
export const ActivationReport = "Activation Report";

export const LevewiseRepotOption = [
  { optionName: "1" },
  { optionName: "2" },
  { optionName: "3" },
  { optionName: "4" },
  { optionName: "5" },
  { optionName: "6" },
  { optionName: "7" },
  { optionName: "8" },
  { optionName: "9" },
  // { optionName: "10" },
  // { optionName: "11" },
  // { optionName: "12" },
  // { optionName: "13" },
  // { optionName: "14" },
  // { optionName: "15" },
  // { optionName: "16" },
  // { optionName: "17" },
  // { optionName: "18" },
  // { optionName: "19" },
  // { optionName: "20" },
  // { optionName: "21" },
  // { optionName: "22" },
  { optionName: "All" },
  // {optionName:'23'},
  // {optionName:'24'},
  // {optionName:'25'}
];

//FXST Token Deposit
export const FSXTTokenTitle = "FXST Token";

export const SupportTicket = "Support Ticket";

export const LossSupportTicket = "LossSupportTicket";

export const ProfitSupportTicket = "ProfitSupportTicket";

export const DeleteData = "DeleteData";
export const DeleteSupportTicket = "DeleteSupportTicket";

//Incomes
export const Epin = "E-Pin";
export const LevelIncomeReport = "Level Income Report";
export const RewardStatusTitle = "Reward Status Report";
export const RewardIncomeTitle = "Reward Income";
export const TotalEarningTitle = "Total Earning";
export const SearchPinTital = "Search Pin";
export const TransferPinReport = "Transfer Pin Report";
export const CreatePinTital = "Create Pin";
export const SendMultiplePin = "Send Multiple Pin";
export const pinOrderReport = "Pin Order Report";
